module.exports = __webpack_public_path__ + "img/section5-item1.d5470966.png";